import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  INVESTMENT_WRAPPER_OPTIONS,
  InvestmentWrapper,
} from '@/pages/instruments/new-instrument/constants/investment-wrappers'

export interface InvestmentWrapperFieldProps {}

export const InvestmentWrapperField: React.FC<InvestmentWrapperFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ investment_wrapper: InvestmentWrapper }>()

  return (
    <FormField
      name="investment_wrapper"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Investment Wrapper</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value?.toString()}
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select an investment wrapper'}
              setValue={(value) =>
                setValue('investment_wrapper', value as InvestmentWrapper, { shouldValidate: true })
              }
              options={INVESTMENT_WRAPPER_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
